var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60943e-05 6.67261C-0.000441243 6.50185 0.0325282 6.33312 0.0965503 6.17883C0.160573 6.02454 0.254023 5.88861 0.370033 5.78103L6.36947 0.260032C6.54838 0.0919087 6.7728 -7.18005e-07 7.00441 -6.94996e-07C7.23601 -6.71987e-07 7.46043 0.0919088 7.63935 0.260033L13.6388 5.97535C13.843 6.16937 13.9714 6.44817 13.9958 6.75043C14.0201 7.05269 13.9385 7.35363 13.7688 7.58707C13.599 7.8205 13.3552 7.9673 13.0908 7.99516C12.8264 8.02303 12.5631 7.92969 12.3589 7.73566L6.99941 2.62617L1.63991 7.5642C1.49314 7.70398 1.31442 7.79277 1.12489 7.82007C0.935355 7.84736 0.74295 7.81202 0.570438 7.71823C0.397927 7.62443 0.252528 7.47611 0.151448 7.29081C0.0503666 7.1055 -0.00216553 6.89098 6.60943e-05 6.67261Z",
    fill: "#E9484B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron_up.4d86daef9e7eae1904f3c9a7b7a32567.svg";
export { ForwardRef as ReactComponent };